import { Column, Columns, Box, Hidden } from 'braid-design-system';
import React from 'react';

import { PaymentContainer } from '../PaymentContainer';

import HeroImage from './components/HeroImage/HeroImage';
import SelectedProduct from './components/SelectedProduct/SelectedProduct';

const ConfirmCheckout = () => (
  <PaymentContainer>
    <Box paddingTop={['none', 'medium']} paddingBottom="medium">
      <Columns space="gutter" collapseBelow="tablet" alignY="center">
        <Column width="1/3">
          <SelectedProduct />
        </Column>
        <Hidden below="tablet">
          <Column>
            <HeroImage />
          </Column>
        </Hidden>
      </Columns>
    </Box>
  </PaymentContainer>
);

export default ConfirmCheckout;
